import { createCameraVideoTrack, createMicrophoneAudioTrack } from "../config/sdkConfig";
import { switchPreviewCameraDevice, switchPreviewMicDevice } from "./useAgoraStubs";

const useMediaStream = () => {

  const getVideoTrack = async ({ webcamId, encoderConfig }) => {
    try {
      const track = await createCameraVideoTrack({
        cameraId: webcamId ,
        encoderConfig: encoderConfig ?  encoderConfig :"h1080p_w1920p",
        optimizationMode: "motion",
        multiStream: false,
      });

      return track;
    } catch(error) {
      return null;
    }
  };

  const getAudioTrack = async ({micId}) => {
    try{
      const track = await createMicrophoneAudioTrack({
        microphoneId: micId
      });
      return track;
    } catch(error) {
      return null;
    }
  };

  // Device-switch variants: prefer setDevice() on the existing Agora preview
  // track (same shape MediaStream is returned). Falls back to creating a new
  // track when no preview exists yet or setDevice throws.
  const switchWebcam = async ({ webcamId }) => {
    try {
      return await switchPreviewCameraDevice(webcamId);
    } catch (error) {
      return null;
    }
  };

  const switchMic = async ({ micId }) => {
    try {
      return await switchPreviewMicDevice(micId);
    } catch (error) {
      return null;
    }
  };

  return { getVideoTrack, getAudioTrack, switchWebcam, switchMic };
};

export default useMediaStream;
